const PLAYLIST_CONTAINER = 'data-video-playlist'
const VIDEO_CONTAINER = 'data-video-iframe'
const PLAYLIST_ITEM = 'data-video-playlist-item'
const ITEM_IFRAME = 'data-video-playlist-item-iframe'


function init(){
  const playlists = document.querySelectorAll(`[${PLAYLIST_CONTAINER}]`)
  if (playlists.length === 0) return
  initPlaylists(playlists)
}

function initPlaylists(playlists) {
  playlists.forEach(playlist => {
    const videoContainer = playlist.querySelector(`[${VIDEO_CONTAINER}]`)
    const items = playlist.querySelectorAll(`[${PLAYLIST_ITEM}]`)

    items.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault()
        // toggle video
        const iframe = item.querySelector(`[${ITEM_IFRAME}]`).innerHTML
        videoContainer.innerHTML = iframe
        videoContainer.dataset.iframe = iframe
        // remove previous item for being watched
        const currentItem = playlist.querySelector(`[${PLAYLIST_ITEM}].current`)
        currentItem.classList.remove('current')
        // set item as being watched
        item.classList.add('current')
      })
    })
  })
}

export default { init }
